function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "volumeMaxIcon");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Symbols",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Shape"
}, /*#__PURE__*/React.createElement("polygon", {
  points: "0 0 24 0 24 24 5.9604648e-07 24 5.9604648e-07 0"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.9999995,5.11402515 L13.9999995,2.9999998 C18.0099988,3.93386536 20.9999995,7.60775317 20.9999995,11.9999998 C20.9999995,16.3922461 18.0099988,20.0661347 13.9999995,20.9999998 L13.9999995,18.8859745 C16.8899998,18.0034214 18.9999995,15.2531367 18.9999995,11.9999998 C18.9999995,8.74686404 16.8899998,5.99657893 13.9999995,5.11402515 L13.9999995,5.11402515 Z M2.9999995,8.92141206 L2.9999995,15.0787669 L6.9999995,15.0787669 L11.9999995,20.209896 L11.9999995,3.790283 L6.9999995,8.92141206 L2.9999995,8.92141206 L2.9999995,8.92141206 Z M16.4999995,11.9999476 C16.4999995,10.1835281 15.4800001,8.62366486 13.9999995,7.8642578 L13.9999995,16.1253748 C15.4800001,15.3762316 16.4999995,13.8163674 16.4999995,11.9999476 L16.4999995,11.9999476 Z",
  fill: "#EF4E23"
})));

var SvgVolumeMax = function SvgVolumeMax(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgVolumeMax, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/volume-max.99d9568f.svg";
export { ForwardRef as ReactComponent };